<template>
  <div id="dashboard-page">
    <div class="container p-4">
      <b-row>
        <b-col sm="6" lg="3">
          <b-card no-body>
            <b-card-body class="p-3 clearfix">
              <i
                class="fa fa-map-marker bg-primary p-3 font-2xl mr-3 float-left"
              ></i>
              <div class="h2 text-black mb-0 mt-0 mb-1">
                {{ this.mData.diemDenAnToanCount }}
              </div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">
                Tổng đăng ký
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body>
            <b-card-body class="p-3 clearfix">
              <i
                class="fa fa-list-alt bg-success p-3 font-2xl mr-3 float-left"
              ></i>
              <div class="h2 text-black mb-0 mt-0 mb-1">
                {{ this.mData.diemDenAnToanDaKhaiBao }}
              </div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">
                Đã khai báo
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body>
            <b-card-body class="p-3 clearfix">
              <i
                class="fa fa-square-o bg-danger p-3 font-2xl mr-3 float-left"
              ></i>
              <div class="h2 text-black mb-0 mt-0 mb-1">
                {{
                  this.mData.diemDenAnToanCount -
                  this.mData.diemDenAnToanDaKhaiBao
                }}
              </div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">
                Chưa khai báo
              </div>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col sm="6" lg="3">
          <b-card no-body class="cusor-poiter bg-hover-light">
            <el-date-picker
              v-model="mData.filterTime"
              type="date"
              placeholder="Pick a day"
              class="filter-date-hidden"
              @change="selectTimeFilter()"
              :picker-options="mData.pickerOptionsStart"
            >
            </el-date-picker>

            <b-card-body class="p-3 clearfix">
              <i
                class="fa fa-calendar bg-warning p-3 font-2xl mr-3 float-left"
              ></i>
              <div class="h3 text-black mt-1 mb-1">
                {{ mData.today }}
              </div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">
                Click để chọn ngày
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>

      <div class="card">
        <h4 class="card-title text-center m-3">
          Thống kê điểm đến ngày {{ mData.today }}
        </h4>
        <div class="card-body">
          <b-row>
            <b-col sm="7">
              <el-table
                :data="mData.listDiemDenAnToan"
                border
                style="width: 100%"
              >
                <el-table-column prop="" label="STT" width="50" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="Tỉnh/TP">
                  <template slot-scope="scope">
                    <span>{{ scope.row.type }} {{ scope.row.name }}</span>
                  </template></el-table-column
                >
                <el-table-column label="Xếp loại">
                  <el-table-column
                    prop=""
                    label="An toàn"
                    width="100"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.xl_1 }}</span>
                    </template></el-table-column
                  >
                  <el-table-column
                    prop=""
                    label="Có nguy cơ"
                    width="100"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.xl_2 }}</span>
                    </template></el-table-column
                  >
                  <el-table-column
                    prop=""
                    label="Không an toàn"
                    width="110"
                    align="right"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.xl_3 }}</span>
                    </template></el-table-column
                  >
                </el-table-column>

                <el-table-column
                  prop="total"
                  label="Tổng"
                  width="80"
                  align="right"
                ></el-table-column>
              </el-table>
            </b-col>
            <b-col sm="5">
              <el-table
                :data="mData.listDiemDenAnToanByType"
                border
                style="width: 100%"
              >
                <el-table-column prop="" label="STT" width="50" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="Loại hình">
                  <template slot-scope="scope">
                    <span :title="scope.row.name">{{ scope.row.name }}</span>
                  </template></el-table-column
                >
                <el-table-column
                  prop="count"
                  label="Số lượng"
                  width="100"
                  align="right"
                ></el-table-column>
              </el-table>

              <b-row class="mt-5">
                <b-col sm="12" class="text-center mb-2">
                  <h5>Thống kê các loại hình ngày {{ mData.today }}</h5>
                </b-col>
                <b-col sm="12" id="myChartBar">
                  <!-- <canvas id="myChart" width="400" height="400"></canvas> -->
                </b-col>
              </b-row>

              <b-row class="mt-5">
                <b-col sm="12" class="text-center mb-2">
                  <h5>Thống kê khai báo ngày {{ mData.today }}</h5>
                </b-col>
                <b-col sm="1"></b-col>
                <b-col sm="10" id="myChartPie">
                  <!-- <canvas width="400" height="400"></canvas> -->
                </b-col>
                <b-col sm="1"></b-col>
              </b-row>
              <b-row class="mt-5">
                <b-col sm="12" class="text-center mb-2">
                  <h5>Số tỉnh khai báo từ 9/11/2020 - {{ mData.today }}</h5>
                </b-col>
                <b-col sm="6" class="text-center mb-2" @click="toggleTableDeclaredProvinces">
                  <el-card class="box-card text-center bg-primary">
                    <p class="h2 text-black text-left mb-0 mt-0 mb-1">{{mData.total_declared_count_provinces}}</p>
                    <p class="text-light text-uppercase font-weight-bold font-xs text-left">Số tỉnh đã khai báo</p>
                  </el-card>
                </b-col>
                <b-col sm="6" class="text-center mb-2" @click="toggleTableUnDeclaredProvinces">
                  <el-card class="box-card text-center bg-danger">
                    <p class="h2 text-black text-left mb-0 mt-0 mb-1">{{63 - mData.total_declared_count_provinces}}</p>
                    <p class="text-light text-uppercase font-weight-bold font-xs text-left">Số tỉnh chưa khai báo</p>
                  </el-card>
                </b-col>
                <b-col sm="12 mt-3">
                  <el-table
                    :data="mData.ListStatsTotalDeclaredprovinces"
                    border
                    style="width: 100%"
                    v-if="mData.isOpenTableDeclaredProvince"
                  >
                    <el-table-column prop="" label="STT" width="50" align="center">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="province_name" label="Tỉnh">
                    </el-table-column>
                  </el-table>
                  <el-table
                    :data="mData.ListStatsTotalUnDeclaredprovinces"
                    border
                    style="width: 100%"
                    v-if="mData.isOpenTableUnDeclaredProvince"
                  >
                    <el-table-column prop="" label="STT" width="50" align="center">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="Tỉnh">
                    </el-table-column>
                  </el-table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardApi from "../../moduleApi/DashboardApi";
// import LanguageService from "../../service/LanguageService";
// import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
// import DataService from "../../service/DataService";
// import AuthService from "../../service/AuthService";
import ProvinceApi from "../../moduleApi/ProvinceApi";
var Chart = require("chart.js");

export default {
  data() {
    return {
      // aLang: LanguageService.lang,
      mData: {
        dataDefault: {},
        dataForm: {},
        validForm: {},

        title: "Thống kê điểm đến",

        listDiemDenAnToan: [],

        listDiemDenAnToanAll: [],
        totalCountDiemDenAnToanAll: 0,

        listDiemDenAnToanToday: [],
        totalCountDiemDenAnToanToday: 0,

        listDiemDenAnToan7day: [],
        totalCountDiemDenAnToan7day: 0,

        listDiemDenAnToan30day: [],
        totalCountDiemDenAnToan30day: 0,

        listDiemDenAnToanBytype: [],
        listDiemDenAnToanBytypeAll: [],
        listDiemDenAnToanBytypeToday: [],
        listDiemDenAnToanBytype7day: [],
        listDiemDenAnToanBytype30day: [],
        ListStatsTotalDeclaredprovinces: [],
        ListStatsTotalUnDeclaredprovinces: [],

        diemDenAnToanCount: 0,
        diemDenAnToanDaKhaiBao: 0,
        diemDenAnToanChuaKhaiBao: 0,

        today: "",
        filterTime: "",

        pickerOptionsStart: {
          disabledDate: function (time) {
            let startDate = new Date("2020-11-08T17:00:00.000Z");
            return time.getTime() < startDate.getTime();
          },
        },

        myChartBar: null,
        myChartPie: null,
        total_declared_count_provinces: null,
        isOpenTableDeclaredProvince: false,
        isOpenTableUnDeclaredProvince: false
      },
    };
  },
  methods: {
    async fn_initData(day) {
      let paramsToday = this.getParamsTimeToday();

      if (day) {
        paramsToday = this.getParamsTimeToByDay(day);
      }
      // let params7day = this.getParamsTime7day();
      // let params30day = this.getParamsTime30day();

      let req1 = DashboardApi.getDiemDenAnToanDaily(paramsToday);

      // let req2 = DashboardApi.getDiemDenAnToanToday(paramsToday);
      // let req3 = DashboardApi.getDiemDenAnToan7day(params7day);
      // let req4 = DashboardApi.getDiemDenAnToan30day(params30day);

      let req5 = DashboardApi.getDiemDenAnToanByTypeByTime(paramsToday);
      // let req6 = DashboardApi.getDiemDenAnToanByTypeToday(paramsToday);
      // let req7 = DashboardApi.getDiemDenAnToanByType7day(params7day);
      // let req8 = DashboardApi.getDiemDenAnToanByType30day(params30day);

      let req9 = DashboardApi.getDiemDenAnToanCount(paramsToday);
      let req10 = DashboardApi.getDiemDenAnToanDaKhaiBao(paramsToday);

      this.getTotalDeclaredCountProvinces(paramsToday);
      this.getStatsTotalDeclaredprovinces(paramsToday);


      let resDiemDenAnToanAll = await req1;
      // let resDiemDenAnToanToday = await req2;
      // let resDiemDenAnToan7day = await req3;
      // let resDiemDenAnToan30day = await req4;

      let resDiemDenAnToanByTypeAll = await req5;
      // let resDiemDenAnToanByTypeToday = await req6;
      // let resDiemDenAnToanByType7day = await req7;
      // let resDiemDenAnToanByType30day = await req8;

      let resDiemDenAnToanCount = await req9;
      let resDiemDenAnToanDaKhaiBao = await req10;

      if (resDiemDenAnToanAll.result && resDiemDenAnToanAll.result.length > 0) {
        if (resDiemDenAnToanAll.result.length == 64) resDiemDenAnToanAll.result.length = 63;
        this.mData.listDiemDenAnToan = this.mData.listDiemDenAnToanAll =
          resDiemDenAnToanAll.result;
        this.countTotalDiemDenAnToanAll(resDiemDenAnToanAll.result);
      }
      // if (
      //   resDiemDenAnToanToday.result &&
      //   resDiemDenAnToanToday.result.length > 0
      // ) {
      //   this.mData.listDiemDenAnToanToday = resDiemDenAnToanToday.result;
      //   this.countTotalDiemDenAnToanToday(resDiemDenAnToanToday.result);
      // }
      // if (
      //   resDiemDenAnToan7day.result &&
      //   resDiemDenAnToan7day.result.length > 0
      // ) {
      //   this.mData.listDiemDenAnToan7day = resDiemDenAnToan7day.result;
      //   this.countTotalDiemDenAnToan7day(resDiemDenAnToan7day.result);
      // }
      // if (
      //   resDiemDenAnToan30day.result &&
      //   resDiemDenAnToan30day.result.length > 0
      // ) {
      //   this.mData.listDiemDenAnToan30day = resDiemDenAnToan30day.result;
      //   this.countTotalDiemDenAnToan30day(resDiemDenAnToan30day.result);
      // }

      if (
        resDiemDenAnToanByTypeAll.result &&
        resDiemDenAnToanByTypeAll.result.length > 0
      ) {
        let dataNew = this.formatLoaiHinh(resDiemDenAnToanByTypeAll.result);
        dataNew.sort((a, b) => a.name == b.name ? 0 : a.name > b.name ? 1 : -1);
        this.mData.listDiemDenAnToanByType = this.mData.listDiemDenAnToanByTypeAll = dataNew;
        this.initChartBar(dataNew);
      }

      // if (
      //   resDiemDenAnToanByTypeToday.result &&
      //   resDiemDenAnToanByTypeToday.result.length > 0
      // ) {
      //   this.mData.listDiemDenAnToanByTypeToday =
      //     resDiemDenAnToanByTypeToday.result;
      // }

      // if (
      //   resDiemDenAnToanByType7day.result &&
      //   resDiemDenAnToanByType7day.result.length > 0
      // ) {
      //   this.mData.listDiemDenAnToanByType7day =
      //     resDiemDenAnToanByType7day.result;
      // }

      // if (
      //   resDiemDenAnToanByType30day.result &&
      //   resDiemDenAnToanByType30day.result.length > 0
      // ) {
      //   this.mData.listDiemDenAnToanByType30day =
      //     resDiemDenAnToanByType30day.result;
      // }

      if (
        resDiemDenAnToanCount.result &&
        resDiemDenAnToanCount.result.length > 0
      ) {
        this.mData.diemDenAnToanCount = resDiemDenAnToanCount.result[0].count;
      }
      if (
        resDiemDenAnToanDaKhaiBao.result &&
        resDiemDenAnToanDaKhaiBao.result.length > 0
      ) {
        this.mData.diemDenAnToanDaKhaiBao =
          resDiemDenAnToanDaKhaiBao.result[0].count;
        this.initChartPie();
      }
    },

    setToday() {
      let d = new Date();
      this.mData.today = MethodService.formatDate(d, "date");
    },

    getParamsTimeToday() {
      let params = {};

      let d = new Date();
      d.setHours(0, 0, 0, 0);

      let fromDate = d.toISOString();
      d.setDate(d.getDate() + 1);
      let toDate = d.toISOString();

      params = { from: fromDate, to: toDate };

      return params;
    },

    getParamsTimeToByDay(day) {
      let params = {};

      let d = new Date(day);
      d.setHours(0, 0, 0, 0);

      let fromDate = d.toISOString();
      d.setDate(d.getDate() + 1);
      let toDate = d.toISOString();

      params = { from: fromDate, to: toDate };

      return params;
    },

    getParamsTime7day() {
      let params = {};

      let dFrom = new Date();
      dFrom.setHours(0, 0, 0, 0);
      dFrom.setDate(dFrom.getDate() - 6);
      let fromDate = dFrom.toISOString();

      let dTo = new Date();
      dTo.setHours(0, 0, 0, 0);
      dTo.setDate(dTo.getDate() + 1);
      let toDate = dTo.toISOString();

      params = { from: fromDate, to: toDate };

      return params;
    },

    getParamsTime30day() {
      let params = {};

      let dFrom = new Date();
      dFrom.setHours(0, 0, 0, 0);
      dFrom.setDate(dFrom.getDate() - 30);
      let fromDate = dFrom.toISOString();

      let dTo = new Date();
      dTo.setHours(0, 0, 0, 0);
      dTo.setDate(dTo.getDate() + 1);
      let toDate = dTo.toISOString();

      params = { from: fromDate, to: toDate };

      return params;
    },

    countTotalDiemDenAnToanAll(data) {
      let count = 0;
      data.forEach((el) => {
        count += el.count;
      });
      this.mData.totalCountDiemDenAnToanAll = count;
    },
    countTotalDiemDenAnToanToday(data) {
      let count = 0;
      data.forEach((el) => {
        count += el.count;
      });
      this.mData.totalCountDiemDenAnToanToday = count;
    },
    countTotalDiemDenAnToan7day(data) {
      let count = 0;
      data.forEach((el) => {
        count += el.count;
      });
      this.mData.totalCountDiemDenAnToan7day = count;
    },
    countTotalDiemDenAnToan30day(data) {
      let count = 0;
      data.forEach((el) => {
        count += el.count;
      });
      this.mData.totalCountDiemDenAnToan30day = count;
    },

    changeFilter(type) {
      switch (type) {
        case "all":
          this.mData.listDiemDenAnToan = this.mData.listDiemDenAnToanAll;
          this.mData.listDiemDenAnToanByType = this.mData.listDiemDenAnToanByTypeAll;

          this.mData.fromDate = "";
          this.mData.toDate = "";
          this.mData.title = "Thống kê điểm đến toàn quốc";
          break;

        case "today": {
          this.mData.listDiemDenAnToan = this.mData.listDiemDenAnToanToday;
          this.mData.listDiemDenAnToanByType = this.mData.listDiemDenAnToanByTypeToday;

          let params = this.getParamsTimeToday();

          let fromDate = MethodService.formatDate(params.from, "date");
          // let toDate = MethodService.formatDate(params.to, "date");

          this.mData.title = `Thống kê điểm đến hôm nay ngày ${fromDate}`;

          break;
        }
        case "7day": {
          this.mData.listDiemDenAnToan = this.mData.listDiemDenAnToan7day;
          this.mData.listDiemDenAnToanByType = this.mData.listDiemDenAnToanByType7day;

          let params = this.getParamsTime7day();
          let fromDate = MethodService.formatDate(params.from, "date");
          let toDate = MethodService.formatDate(params.to, "date");

          this.mData.title = `Thống kê điểm đến 7 ngày từ ${fromDate} đến ${toDate}`;
          break;
        }
        case "30day": {
          this.mData.listDiemDenAnToan = this.mData.listDiemDenAnToan30day;
          this.mData.listDiemDenAnToanByType = this.mData.listDiemDenAnToanByType30day;

          let params = this.getParamsTime30day();
          let fromDate = MethodService.formatDate(params.from, "date");
          let toDate = MethodService.formatDate(params.to, "date");
          this.mData.title = `Thống kê điểm đến 30 ngày từ ${fromDate} đến ${toDate}`;
          break;
        }
        default:
          break;
      }
    },

    formatLoaiHinh(arrData) {
      arrData.map(function (item) {
        switch (item.id) {
          case "tourist_apartment":
            item.name = "Căn hộ du lịch";
            break;
          case "hotel":
            item.name = "Khách sạn";
            break;
          case "motel":
            item.name = "Nhà nghỉ du lịch";
            break;
          case "tourist_cruise":
            item.name = "Tầu thủy lưu trú du lịch";
            break;
          case "camping":
            item.name = "Bãi cắm trại du lịch";
            break;
          case "homestay":
            //item.name = "Nhà ở có phòng cho khách du lịch thuê/Homestay";
            item.name = "Homestay";
            break;
          case "tourist_villa":
            item.name = "Biệt thự du lịch";
            break;
          default:
            item.name = "";
            break;
        }
      });
      return arrData;
    },

    selectTimeFilter() {
      // vm.$emit("pick", new Date());
      this.mData.today = MethodService.formatDate(
        this.mData.filterTime,
        "date"
      );
      this.fn_initData(this.mData.filterTime);
    },

    initChartBar(dataChart) {
      var ctx = null;

      if (this.mData.myChartBar) {
        document.getElementById("myChartBar").innerHTML = "";
      }
      document.getElementById("myChartBar").innerHTML =
        '<canvas id="myChartBar-render" width="400" height="400"></canvas>';
      ctx = document.getElementById("myChartBar-render").getContext("2d");

      let labels = [];
      let dataSet = [];

      dataChart.forEach((item) => {
        /* if (item.id == "homestay") {
          labels.push("Homestay");
        } else {
          labels.push(item.name);
        } */
        labels.push(item.name);
        dataSet.push(item.count);
      });

      var myChart = new Chart(ctx, {
        type: "bar",
        options: {
          legend: {
            display: false,
            labels: {
              fontColor: "#444",
            },
          },
          // title: {
          //   display: true,
          //   position: "center",
          // },
        },
        data: {
          labels: labels,

          datasets: [
            {
              label: "",
              data: dataSet,
              backgroundColor: [
                "#4dbd7459",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)",
                "rgba(75, 192, 192, 0.2)",
                "rgba(153, 102, 255, 0.2)",
                "rgba(255, 159, 64, 0.2)",
                "rgba(255, 99, 132, 0.2)",
              ],
              borderColor: [
                "#4dbd74",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)",
                "rgba(75, 192, 192, 1)",
                "rgba(153, 102, 255, 1)",
                "rgba(255, 159, 64, 1)",
                "rgba(255, 99, 132, 1)",
              ],

              borderWidth: 1,
            },
          ],
        },
      });
      this.mData.myChartBar = myChart;
    },
    initChartPie() {
      var ctx = null;

      if (this.mData.myChartPie) {
        document.getElementById("myChartPie").innerHTML = "";
      }
      document.getElementById("myChartPie").innerHTML =
        '<canvas id="myChartPie-render" width="400" height="400"></canvas>';
      ctx = document.getElementById("myChartPie-render").getContext("2d");
      let dataSet = [
        this.mData.diemDenAnToanDaKhaiBao,
        this.mData.diemDenAnToanCount - this.mData.diemDenAnToanDaKhaiBao,
      ];

      var myChart = new Chart(ctx, {
        type: "doughnut",
        options: {},
        data: {
          labels: ["Đã khai báo", "Chưa khai báo"],

          datasets: [
            {
              label: "",
              data: dataSet,
              backgroundColor: ["#4dbd7459", "rgba(255, 99, 132, 0.2)"],
              borderColor: ["#4dbd74", "rgba(255, 99, 132, 1)"],

              borderWidth: 1,
            },
          ],
        },
      });

      this.mData.myChartPie = myChart;
    },

    async getTotalDeclaredCountProvinces(paramsToday) {
      try {
        const TotalDeclaredCountProvince = await DashboardApi.getTotalDeclaredCountProvince(paramsToday);
        if (TotalDeclaredCountProvince) {
          this.mData.total_declared_count_provinces = TotalDeclaredCountProvince.result[0].count;
        }
      }
      catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async getStatsTotalDeclaredprovinces(paramsToday) {
      try {
        const TotalDeclaredProvince = await DashboardApi.getStatsTotalDeclaredprovince(paramsToday);
        if (TotalDeclaredProvince.result.length) {
          this.mData.ListStatsTotalDeclaredprovinces = TotalDeclaredProvince.result[0].count;
        }
        else {
          this.mData.ListStatsTotalDeclaredprovinces = [];
        }
      }
      catch (e) {
        this.mData.ListStatsTotalDeclaredprovinces = [];
        this.mData.ListStatsTotalUnDeclaredprovinces = [];
        console.error("Có lỗi: %o", e);
        return;
      }
      try {
        const provinces = await ProvinceApi.list({limit: 200});
        this.mData.ListStatsTotalUnDeclaredprovinces = provinces.result.filter(p => {
          return !this.mData.ListStatsTotalDeclaredprovinces.some(dp => dp._id === p.id);
        });
        console.log('this.mData.ListStatsTotalUnDeclaredprovinces', this.mData.ListStatsTotalUnDeclaredprovinces)
      } catch (error) {
        console.log('error', error)
      }
    },

    toggleTableDeclaredProvinces() {
      this.mData.isOpenTableDeclaredProvince = !this.mData.isOpenTableDeclaredProvince;
      this.mData.isOpenTableUnDeclaredProvince = false;
    },

    toggleTableUnDeclaredProvinces() {
      this.mData.isOpenTableUnDeclaredProvince = !this.mData.isOpenTableUnDeclaredProvince;
      this.mData.isOpenTableDeclaredProvince = false;
    }
  },

  mounted() {
    this.setToday();
    this.fn_initData();
    document.querySelector(
      ".filter-date-hidden .el-input__inner"
    ).style.height = "88px";
    document.querySelector(
      ".filter-date-hidden .el-input__inner"
    ).style.cursor = "pointer";

    // this.initChartBar();

    // this.initChartPie();
  },
  created() {},
};
</script>
<style scoped>
.el-table thead.is-group th {
  background: #f5f7fa;
  color: #444;
}
.filter-date-hidden {
  opacity: 0;
  position: absolute;
  cursor: pointer;
}

#dashboard-page {
  background-image: url("~/img/background.jpg");
  background-size: cover;
  background-attachment: fixed;
}
</style>
